// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__N8fSQ","clickedWithMouse":"MenuLabel_clickedWithMouse__35O1C","isOpen":"MenuLabel_isOpen__38S1w"};